export default __webpack_public_path__ + "static/media/centris_data_transfer_profile_button_fr.6fd0b61f.png";